export var PluginType;
(function (PluginType) {
  PluginType["BEFORE"] = "before";
  PluginType["ENRICHMENT"] = "enrichment";
  PluginType["DESTINATION"] = "destination";
})(PluginType || (PluginType = {}));